<template>
    <div class="mine-home-page">
        <div class="banner">
            <img class="avatar" src="../../assets/img/icons/icon-mine-avatar.png" />
            <p>
                当前角色：
                <span v-if="userRoles">
                    {{ userRoles.is_customer ? "客户" : "" }}
                    {{ userRoles.is_designer ? "设计师" : "" }}
                    {{ userRoles.is_visitor ? "游客" : "" }}
                </span>
                <span v-else>游客</span>
            </p>
        </div>
        <div class="nav-list">
            <router-link class="list-item" to="order" v-if="isLoggedIn">
                <van-icon class="item-left" name="notes-o" />
                <span>我的订单</span>
                <van-icon class="item-right" name="arrow" />
            </router-link>
            <router-link class="list-item" to="password" v-if="isLoggedIn">
                <van-icon class="item-left" name="lock" />
                <span>修改密码</span>
                <van-icon class="item-right" name="arrow" />
            </router-link>
            <router-link class="list-item" to="client" v-if="userRoles && userRoles.is_designer">
                <van-icon class="item-left" name="user-o" />
                <span>我的客户</span>
                <van-icon class="item-right" name="arrow" />
            </router-link>
            <router-link class="list-item" to="apply" v-if="userRoles && userRoles.is_visitor">
                <van-icon class="item-left" name="user-o" />
                <span>申请成为设计师 </span>
                <van-icon class="item-right" name="arrow" />
            </router-link>
            <div class="list-item" @click="goToLogin" v-if="!isLoggedIn">
                <van-icon class="item-left" name="user-o" />
                <span>立即登录</span>
                <van-icon class="item-right" name="arrow" />
            </div>
        </div>
        <van-button 
            v-if="isLoggedIn"
            block 
            class="logout-button" 
            color="#F54A4A" 
            type="primary" 
            @click="logout()"
        >
            退&nbsp;&nbsp;出
        </van-button>
        <van-button 
            v-else
            block 
            class="logout-button" 
            color="#6b4d9a" 
            type="primary" 
            @click="goToLogin()"
        >
            立即登录
        </van-button>
    </div>
</template>

<script>
// 引入mixins
import mixins_config from "@/mixins/config.js"; // 引入组件
import GeekQooSearch from "@/components/GeekQooSearch"; // 引入接口
import { LOGOUT } from "@/api/dataProvider"; // 引入本地存储操作
import {clearLocalStorage, delCookie, getCookie} from "@/utils/storage";
import wx from "weixin-js-sdk";

export default {
    name: "MineHome",
    mixins: [mixins_config],
    components: { GeekQooSearch },
    data() {
        return {};
    },
    computed: {
        // 检查用户是否已登录
        isLoggedIn() {
            return !!(this.app.userData && getCookie("token"));
        },
        // 安全获取用户角色信息
        userRoles() {
            return this.app.userData && this.app.userData.roles ? this.app.userData.roles : null;
        }
    },
    created() {},
    mounted() {},
    methods: {
        logout() {
            let that = this;
            LOGOUT({}, function (res) {
                if (res.data.code == 0) {
                    delCookie("token");
                    clearLocalStorage("userData")
                    that.$notify({
                        type: "success",
                        message: "退出成功，即将跳转登录页！",
                        onClose() {
                            // that.$router.push({ name: "Login" });
                            wx.miniProgram.navigateTo({
                                url: "/pages/login/index"
                            });
                        }
                    });
                }
            });
        },
        goToLogin() {
            // 判断是否在小程序环境
            if (window.__wxjs_environment === 'miniprogram') {
                // 在小程序环境中，直接跳转到login页面
                wx.miniProgram.navigateTo({
                    url: "/pages/login/index"
                });
            } else {
                // 在浏览器环境中，使用H5路由跳转
                this.$router.push({name: "Login"});
            }
        }
    }
};
</script>

<style lang="scss">
.mine-home-page {
    .banner {
        width: 100%;
        height: 156px;
        padding: 27px 0 0 0;
        background: url("../../assets/img/login/bg.png") no-repeat;
        background-size: cover;
        background-position: center;

        .avatar {
            display: block;
            width: 69px;
            height: 69px;
            margin: 0 auto;
        }

        p {
            margin: 14px 0 0 0;
            text-align: center;
            font-size: 14px;
            color: #fff;
        }
    }

    .nav-list {
        padding: 0 17px;

        .list-item {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 0.5px solid #eeeeee;

            .item-left {
                font-size: 14px;
                color: #6b4d9a;
            }

            span {
                margin-left: 6px;
                font-size: 10px;
                color: #2d2d2d;
            }

            .item-right {
                margin-left: auto;
                font-size: 14px;
                color: #999999;
            }
        }
    }

    .logout-button {
        width: 306px;
        margin: 44px auto 0 auto;
        font-size: 10px;
    }
}
</style>
